import {faCheck, faClock, faTimes, faTruck} from "@fortawesome/free-solid-svg-icons";
import PickupTypes from "../../Models/PickupTypes";
import DashboardColumn from "../../Models/DashboardColumn";

export const COLUMN_PENDING: DashboardColumn = {
  id: "DROPPABLE-0",
  name: PickupTypes.PENDIENTE.toUpperCase(),
  alternativeName: PickupTypes.PENDIENTE.toUpperCase(),
  icon: faClock,
  background: "#FF0000",
  borderColor: "#FF0000",
  textColor: "#FFF",
  secondaryBackground: "white"
};

export const COLUMN_SCHEDULED: DashboardColumn = {
  id: "DROPPABLE-1",
  name: PickupTypes.AGENDADA.toUpperCase(),
  alternativeName: PickupTypes.AGENDADA.toUpperCase(),
  icon: faCheck,
  background: "#DAF3D6",
  borderColor: "#D0EDC3",
  textColor: "#3c763d",
  secondaryBackground: "#177C38"
};

export const COLUMN_PICKUPS: DashboardColumn =  {
  id: "DROPPABLE-2",
  name: PickupTypes.RECOGIDA.toUpperCase(),
  alternativeName: PickupTypes.RECOGIDA.toUpperCase(),
  icon: faTruck,
  background: "#D4EEF9",
  borderColor: "#B0EAF4",
  textColor: "#087093",
  secondaryBackground: "#087093"
};

export const COLUMN_CANCELED: DashboardColumn = {
  // PickupTypes.CANCELADA,
  id: "DROPPABLE-3",
  name: "CANCELADA/INCOMPLETA",
  alternativeName: PickupTypes.CANCELADA.toUpperCase(),
  icon: faTimes,
  background: "#F5F5F5",
  borderColor: "#DBDBDB",
  textColor: "#333333",
  secondaryBackground: "#333333"
};

export const COLUMN_TRANSIT: DashboardColumn = {
  // PickupTypes.CANCELADA,
  id: "DROPPABLE-3",
  name: "CANCELADA/INCOMPLETA",
  alternativeName: PickupTypes.CANCELADA.toUpperCase(),
  icon: faTimes,
  background: "#FFFFA2",
  borderColor: "#ffff4d",
  textColor: "#333333",
  secondaryBackground: "#333333"
};

export const COLUMNS: Array<DashboardColumn> = [
  COLUMN_PENDING,
  COLUMN_SCHEDULED,
  COLUMN_PICKUPS,
  COLUMN_CANCELED
];

export const FORMAT_DATE_DD_MM_YYYY = "DD MM YYYY";
